module.exports = __webpack_public_path__ + "static/media/hub-bg.2c0cefb5.png";